import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_FAC020_Request,
  IAPI_FAC020_Response,
} from "../../../type/apiType/index";
import {
  IAPI_FAC039_Request,
  IAPI_FAC039_Response,
} from "../../../type/apiType/index";
import {
  IAPI_COM005_Request,
  IAPI_COM005_Response,
} from "../../../type/apiType/index";
import {
  IAPI_FAC011_Request,
  IAPI_FAC011_Response,
} from "../../../type/apiType/index";
import {
  IAPI_COM009_Request,
  IAPI_COM009_Response,
} from "../../../type/apiType/index";

// 部分解除施設詳細参照API
const httpIAPI_FAC020 = async (
  param: IAPI_FAC020_Request
): Promise<IAPI_FAC020_Response> => {
  const res = await http.post(ApiUrl.API_FAC020, { ...param });
  return res.data;
};

// 部分解除同意書帳票要求更新API
const httpIAPI_FAC039 = async (
  param: IAPI_FAC039_Request
): Promise<IAPI_FAC039_Response> => {
  const res = await http.post(ApiUrl.API_FAC039, { ...param });
  return res.data;
};

// 帳票ダウンロードAPI
const httpIAPI_COM005 = async (
  param: IAPI_COM005_Request
): Promise<IAPI_COM005_Response> => {
  const res = await http.post(ApiUrl.API_COM005, { ...param });
  return res.data;
};

// 退職手当共済契約部分解除更新API
const httpIAPI_FAC011 = async (
  param: IAPI_FAC011_Request
): Promise<IAPI_FAC011_Response> => {
  const res = await http.post(ApiUrl.API_FAC011, { ...param });
  return res.data;
};

// 帳票作成状況取得API
const httpAPI_COM009 = async (
  param: IAPI_COM009_Request
): Promise<IAPI_COM009_Response> => {
  let res = await http.post(ApiUrl.API_COM009, {
    ...param,
  });

  return res.data;
};

export {
  httpIAPI_FAC020,
  httpIAPI_FAC039,
  httpIAPI_FAC011,
  httpIAPI_COM005,
  httpAPI_COM009,
};
